module.exports = __webpack_public_path__ + "img/no-image.4fee3759.png";